<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    {{ newFacility ? "Create New Facility" : "Facility" }}
  </div>
  <div *ngIf="newFacility" class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveNewFacility()"
      [disabled]="saveDisabled"
    >
      Save New Facility
    </button>
  </div>
  <div *ngIf="!newFacility" class="header-right">
    <button mat-button color="warn" (click)="deleteFacility()">
      Delete Facility
    </button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveFacilityUpdates()"
      [disabled]="saveDisabled"
    >
      Save Facility Updates
    </button>
  </div>
</div>

<div class="facility" [ngClass]="{ dragging: draggingFloors }">
  <div class="containers">
    <div class="details-emails">
      <div class="container facility-details-container">
        <div class="container-header no-bottom-border">
          <div class="text">Facility Details</div>
        </div>
        <div class="container-content">
          <div class="container-row">
            <div class="input-box">
              <input
                class="input"
                controlName="placeName"
                [formGroup]="facilityForm!"
                ngx-google-places-autocomplete
                (onAddressChange)="onPlaceChange($event)"
                placeholder="🔍 Search for a location"
              />
            </div>
          </div>

          <div class="container-row">
            <lhpe-input
              class="input"
              controlName="facilityName"
              placeholder="Facility Name"
              [formGroup]="facilityForm!"
              [required]="true"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-input
              class="input"
              controlName="facilityAddress"
              placeholder="Facility address"
              [formGroup]="facilityForm!"
              [required]="true"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-input
              controlName="suiteUnitEtc"
              placeholder="Suite, Unit, etc."
              [formGroup]="facilityForm!"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-input
              class="half-input"
              controlName="city"
              placeholder="City"
              [formGroup]="facilityForm!"
              [required]="true"
            >
            </lhpe-input>
            <lhpe-select
              class="quarter-input"
              controlName="state"
              placeholder="State"
              [formGroup]="facilityForm!"
              [required]="true"
              [options]="statesOptions"
            >
            </lhpe-select>
            <lhpe-input
              class="quarter-input"
              controlName="zip"
              placeholder="Zip"
              [formGroup]="facilityForm!"
              [required]="true"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-input
              class="half-input"
              controlName="lat"
              placeholder="Latitude"
              [formGroup]="facilityForm!"
              [required]="true"
            >
            </lhpe-input>
            <lhpe-input
              class="half-input"
              controlName="lng"
              placeholder="Longitude"
              [formGroup]="facilityForm!"
              [required]="true"
            >
            </lhpe-input>
          </div>

          <div class="container-row">
            <lhpe-input
              controlName="foreign_id"
              placeholder="Foreign ID"
              [formGroup]="facilityForm!"
            >
            </lhpe-input>
          </div>
        </div>
      </div>
      <div class="container facility-emails-container">
        <div class="container-header no-bottom-border">
          <div class="text">Facility Weekly Recap Email Recipients</div>
        </div>
        <div class="container-content">
          <div *ngFor="let email of contactEmails; let i = index" class="row">
            <div class="input-box">
              <input class="input disabled" [value]="email" [disabled]="true" />
            </div>
            <button mat-button class="delete-btn" (click)="deleteEmail(i)">
              <svg-icon
                src="assets/svg/delete.svg"
                [svgStyle]="{
                  'width.px': '25',
                  'height.px': '25'
                }"
              ></svg-icon>
            </button>
          </div>
          <div class="row add-row">
            <div class="input-box">
              <input
                class="input"
                [formControl]="newEmailControl"
                placeholder="Add Email"
              />
            </div>
            <button
              mat-button
              class="add-btn"
              (click)="addNewEmail()"
              [disabled]="newEmailControl.invalid"
            >
              <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!newFacility" class="container facility-floors-container">
      <div class="container-header no-bottom-border">
        <div class="text">Floors</div>
      </div>
      <div class="container-content">
        <div
          class="floors-container"
          cdkDropList
          [cdkDropListData]="facility?.floors"
          (cdkDropListDropped)="floorDragDrop($event)"
        >
          <div
            class="floor-row test-{{ floor.name }}"
            *ngFor="let floor of facility?.floors; let i = index"
            cdkDrag
            cdkDragBoundary=".floors-container"
            cdkDragLockAxis="y"
            (cdkDragStarted)="cdkDragStarted()"
            (cdkDragReleased)="cdkDragReleased()"
          >
            <div class="sort-btn" cdkDragHandle>
              <svg-icon
                src="assets/svg/sort.svg"
                [svgStyle]="{
                  'width.px': '25',
                  'height.px': '25'
                }"
              ></svg-icon>
            </div>
            <div class="input-box floor">
              <input class="input" [(ngModel)]="floor.name" />
            </div>
            <button mat-button class="delete-btn" (click)="deleteFloor(i)">
              <svg-icon
                src="assets/svg/delete.svg"
                [svgStyle]="{
                  'width.px': '25',
                  'height.px': '25'
                }"
              ></svg-icon>
            </button>
          </div>
        </div>
        <div class="new-floor">
          <div class="input-box">
            <input
              class="input"
              [(ngModel)]="newFloorName"
              placeholder="Floor name"
            />
          </div>
          <button
            mat-button
            class="add-btn"
            (click)="addNewFloor()"
            [disabled]="!newFloorName.length"
          >
            <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
          </button>
        </div>
      </div>
    </div>

    <div
      *ngIf="!newFacility"
      class="facility-beacons-container"
      cdkDropListGroup
    >
      <div class="container">
        <div class="container-header no-bottom-border">
          <div class="text">Available Beacons - drag to assign</div>
        </div>
        <div class="container-content">
          <div class="unassigned-beacons">
            <div class="floor-name">
              <div class="input-box">
                <input
                  class="input"
                  [(ngModel)]="beaconSearchText"
                  placeholder="Search"
                />
              </div>
            </div>
            <div class="drop">
              <mat-chip-list
                #chipList
                aria-label="Beacon selection"
                cdkDropList
                (cdkDropListDropped)="onDropBeacon($event)"
                [cdkDropListData]="{
                  list: 'unassigned',
                  obj: unassignedBeacons
                }"
              >
                <mat-chip
                  *ngFor="
                    let beacon of unassignedBeacons
                      | beaconFilter: beaconSearchText;
                    let bi = index
                  "
                  cdkDrag
                  [cdkDragData]="beacon"
                >
                  {{ beacon.name }}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="container-header no-bottom-border">
          <div class="text">Assigned Beacons</div>
        </div>
        <div class="container-content">
          <div
            class="floor"
            *ngFor="let floor of facility?.floors; let i = index"
          >
            <div class="floor-name">{{ floor.name }}</div>
            <div class="drop">
              <mat-chip-list
                #chipList
                aria-label="Beacon selection"
                cdkDropList
                (cdkDropListDropped)="onDropBeacon($event)"
                [cdkDropListData]="{ list: 'floor', obj: floor }"
              >
                <mat-chip
                  selected
                  *ngFor="let beacon of floor.beacons; let bi = index"
                  cdkDrag
                  [cdkDragData]="beacon"
                  (removed)="onBeaconRemove(beacon)"
                >
                  {{ beacon.name }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
